<template>
  <div
    class="modal-inner max-h-full"
    :class="{
      'w-full flex-1': fullscreen,
      'mx-auto my-auto': !fullscreen,
      [modalInnerClasses]: true
    }"
  >
    <div
      class="modal-container text-color-regular text-left flex flex-col w-full max-h-full"
      :class="{ 'h-full': fullscreen }"
      @click.stop
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalInner",
  props: {
    fullscreen: {
      type: Boolean,
      default: true
    },
    modalInnerClasses: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.news-overlays .modal-inner,
.vote-overlays .modal-inner {
  min-width: 80%;
  max-height: 100%;
  max-width: 100%;
}
.news-overlays .modal-container,
.vote-overlays .modal-container {
  height: 100%;
}

.modal-inner {
  background: white;
  border-radius: 2rem;
  min-width: min(360px, 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}
.modal-container {
  padding: 1.232rem;
}
@media screen and (min-width: 540px) {
  .news-overlays .modal-inner,
  .vote-overlays .modal-inner {
    min-width: 400px;
  }
}
@media screen and (min-width: 768px) {
  .modal-container {
    padding: 1.472rem;
  }
}
@media screen and (min-width: 1024px) {
  .news-overlays .modal-inner,
  .vote-overlays .modal-inner {
    min-width: 78%;
  }
}
</style>
